<ng-container [ngSwitch]="renderLink()">
  <a
    *ngSwitchCase="'externalLink'"
    class="link"
    rdOpenInNewTab
    [attr.href]="path"
    tabindex="0">
    <span class="link-text" tabindex="-1"> {{ text }} </span>
    <rd-shared-icon
      *ngIf="!!externalLinkIcon && showIcon"
      [iconSymbol]="externalLinkIcon"></rd-shared-icon>
  </a>

  <a
    *ngSwitchCase="'internalLink'"
    class="link"
    [routerLink]="[path]"
    tabindex="0">
    <span class="link-text" tabindex="-1">{{ text }}</span>
    <rd-shared-icon
      *ngIf="!!internalLinkIcon && showIcon"
      [iconSymbol]="internalLinkIcon"></rd-shared-icon>
  </a>

  <a *ngSwitchCase="'buttonLink'" class="button-link link" tabindex="0">
    <span class="link-text" tabindex="-1">{{ text }}</span>
    <rd-shared-icon
      *ngIf="!!buttonLinkIcon && showIcon"
      [iconSymbol]="buttonLinkIcon"></rd-shared-icon>
  </a>
</ng-container>
